import { useMemo } from 'react';
import { ColumnGroup } from 'react-table';

export const useColumns = () =>
  useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Related Products',
        columns: [
          {
            Header: 'ID',
            accessor: 'id',
          },
          {
            Header: 'Brand',
            accessor: 'brand',
          },
          {
            Header: 'Name',
            accessor: 'name',
          },
          {
            Header: 'Category',
            accessor: 'category',
          },
          {
            Header: 'Sub-category',
            accessor: 'subCategory',
          },
        ],
      },
    ],
    []
  );
